export default {
  subject: (enhancedLease) => ``,
  body: (enhancedLease) => ``,
}
